<nav aria-label="breadcrumb" role="navigation">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
    <li class="breadcrumb-item active" aria-current="page">Elenco usati</li>
  </ol>
</nav>

<div class="row" style="min-height: 900px;">
  <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
    <form novalidate (ngSubmit)="ricerca()" [formGroup]="form">
      <!--    <form novalidate [formGroup]="form">-->
      <div class="row">
        <div class="col-sm-12">
          <app-conmet-select [formname]="'vclTipologia'" [group]="form" [arr]="tipologie" [val]="'descrizione'"
            [descr]="'descrizione'" [label]="'Tipologia'" [vuoto]="1"
            (keyup)="ricercaInvio($event)"></app-conmet-select>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <label>Ricerca libera</label>
          <app-conmet-input [label]="''" [formname]="'vclTestoLibero'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <label>Km percorsi (Da .. a)</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclKmDa'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclKmA'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <label>Anno immatr. (Da .. a)</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclAnnoDa'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclAnnoA'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <label>Potenza (Kw) (Da .. a)</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclPotenzaNumKwDa'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclPotenzaNumKwA'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <label>Potenza (CV) (Da .. a)</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclPotenzaNumCvDa'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
        <div class="col-sm-6 col-6">
          <app-conmet-input-number [label]="''" [formname]="'vclPotenzaNumCvA'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input-number>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <label>Cilindrata (Da .. a)</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-6">
          <app-conmet-input [label]="''" [formname]="'vclCilindrataNumDa'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input>
        </div>
        <div class="col-sm-6 col-6">
          <app-conmet-input [label]="''" [formname]="'vclCilindrataNumA'" [group]="form"
            (keyup)="ricercaInvio($event)"></app-conmet-input>
        </div>
      </div>
      <!--      <div class="row">-->
      <!--        <div class="col-sm-12">-->
      <!--          <label>Prezzo (Da .. a)</label>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="row">-->
      <!--        <div class="col-sm-6">-->
      <!--          <app-conmet-input [label]="''" [formname]="'vclPrezzoVenditaDa'" [group]="form"></app-conmet-input>-->
      <!--        </div>-->
      <!--        <div class="col-sm-6">-->
      <!--          <app-conmet-input [label]="''" [formname]="'vclPrezzoVenditaA'" [group]="form"></app-conmet-input>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row">
        <div class="col-sm-12">
          <label>Trazione</label>
          <select class='form-control' [attr.placeholder]="'Stato'" [formControlName]="'vclTrazione'"
            (keyup)="ricercaInvio($event)">
            <option value="0">Tutte</option>
            <option value="1">Anteriore</option>
            <option value="2">Integrale</option>
          </select>
        </div>
      </div>
      <div class="row" style="margin-bottom: 10px;">
        <div class="col-sm-12">
          <button id="ricerca" type="submit" class="btn btn-success float-right"
            style="color: #fff; margin-top: 10px; margin-left: 10px;" [disabled]="spin">
            <!--  (click)="ricerca()"  -->
            <span class="{{spin ? '' : 'hide'}}">
              <i class="fas fa-circle-notch fa-spin" style="color:#fff;"></i>
            </span> Ricerca
          </button>
          <button id="cancella" class="btn btn-danger float-right" style="color: #fff; margin-top: 10px;"
            (click)="cancella()">
            Cancella
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-3" *ngFor="let pratica of pratiche"
        style="margin-bottom: 20px; padding-left: 0; padding-right: 0;">
        <div class="card">
          <div class="card-body">
            <app-veicolo-card [veicolo]="pratica" [loggato]="loggato"></app-veicolo-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

